if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        const formData = new FormData(this.form);
        const selectedVariantId = formData.get('id');

        if (!selectedVariantId) {
          this.handleErrorMessage(window.variantStrings?.unavailable || 'Variant unavailable');
          return;
        }

        // Simple Bundles guard (data-bundle-product is set in buy-buttons.liquid):
        // never send a bundle without a selection. The app writes
        // properties[_bundle_selection] on load and on every option change, so it is
        // already in the form at submit time. The form can contain the same property
        // name more than once (theme snippet first, app input last), so check all values.
        // Runs before the loading state is set, nothing to reset on early return.
        if (this.dataset.bundleProduct === 'true' && !this.hasBundleSelection(formData)) {
          this.handleErrorMessage(
            window.variantStrings?.bundleSelectionMissing || 'Bitte wähle zuerst deine Optionen.'
          );
          return;
        }

        const closestProductInfo = this.closest('product-info');
        const closestPersonalizePopup = closestProductInfo?.querySelector('.personalize__custom-popup') ?? null;
        let invalid_counter = 0;
        let personalizedItemCount = 0;

        if (closestPersonalizePopup?.classList.contains('active')) {
          const personalizeInputFields = closestPersonalizePopup.querySelectorAll('.personalize-input');
          if (personalizeInputFields.length > 0) {
            const values = [];
            personalizeInputFields.forEach((personalizeInputField) => {
              const minLength = parseInt(personalizeInputField.getAttribute('minlength'), 10) || 1;
              if (personalizeInputField.value.length < minLength) {
                personalizeInputField.classList.add('invalid_chars');
                setTimeout(() => {
                  personalizeInputField.classList.remove('invalid_chars');
                }, 1000);
                invalid_counter++;
              } else {
                values.push(personalizeInputField.value);
              }
            });

            const combinedValue = values.join(', ');
            if (invalid_counter === 0 && combinedValue !== '') {
              const timestamp = Date.now();
              const variantId = selectedVariantId;
              const quantity = formData.get('quantity') || 1;
              const personalizationFee =
                Number(
                  closestPersonalizePopup.querySelector('.additional_personalize_price')?.dataset
                    .personalizationFee || 0
                ) || 0;
              const addonVariantIdRaw =
                closestPersonalizePopup.querySelector('.additional_personalize_price')?.dataset
                  .personalizeAddonVariantId || '';
              const addonVariantId = /^\d+$/.test(String(addonVariantIdRaw).trim())
                ? String(addonVariantIdRaw).trim()
                : '';

              formData.delete('id');
              formData.delete('quantity');

              formData.append('items[0][id]', variantId);
              formData.append('items[0][quantity]', quantity);
              formData.append('items[0][properties][Personalized Text]', combinedValue);
              formData.append('items[0][properties][_personalized_unique_timestamp]', timestamp);
              personalizedItemCount = 1;

              if (personalizationFee > 0 && !addonVariantId) {
                this.handleErrorMessage('Personalization add-on variant is not configured.');
                return;
              }

              if (personalizationFee > 0 && addonVariantId) {
                formData.append('items[1][id]', addonVariantId);
                formData.append('items[1][quantity]', quantity);
                formData.append('items[1][properties][_additional_product_unique_timestamp]', timestamp);
                personalizedItemCount = 2;
              }
            }
          }
        }

        if (invalid_counter > 0) return;

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        
        
        

        if(this.closest('.product__info-wrapper')){
          const additionalProducts = this.closest('.product__info-wrapper').querySelectorAll('.custom_product .card .bundle-product-checkbox');
          if(additionalProducts){
            let index = personalizedItemCount;
            additionalProducts.forEach((item) => {
              if (item.checked) {
                const productVariantID = item.getAttribute('data-variant-id');
                if (productVariantID) {
                  formData.append(`items[${index}][id]`, productVariantID);
                  formData.append(`items[${index}][quantity]`, 1);
                  index++;
                }
              }
            });
          }
        }

        this.appendBundleLineItemProperties(formData);

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .then(()=>{
            if(closestPersonalizePopup && closestPersonalizePopup.classList.contains('active')){
              closestPersonalizePopup.classList.remove('active');
              document.body.classList.remove('personalize-popup__active');
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
            setTimeout(()=>{
              const _closestProductWrapper = this.form?.closest('.product__info-wrapper');
              const volumeUpsellContainer = _closestProductWrapper.querySelector('.js-volume-upsell');
              if(volumeUpsellContainer){
                const firstUpsellItem = volumeUpsellContainer.querySelectorAll('.custom_volume[name="custom-upsell__volume"]')[0];
                if(firstUpsellItem) firstUpsellItem.checked = true;
              }
            }, 800);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      appendBundleLineItemProperties(formData) {
        const closestProductWrapper = this.form?.closest('.product__info-wrapper');
        if (!closestProductWrapper) return;

        const bundleVariantContainer = closestProductWrapper.querySelectorAll('.bundle_variants_without_redirection');
        if (bundleVariantContainer.length === 0) return;

        const usesItemsArray = formData.has('items[0][id]');

        bundleVariantContainer.forEach((container, index) => {
          const innerInput = container.querySelector('.bundle-input-field');
          if (!innerInput) return;

          const propertyName = innerInput.getAttribute('data-property-name') || innerInput.name?.match(/properties\[(.+)\]/)?.[1];
          if (!propertyName) return;

          const propertyKey = innerInput.name?.startsWith('properties[')
            ? innerInput.name.slice(11, -1)
            : `${propertyName} ${index + 1}`;
          const propertyValue = innerInput.value?.trim();
          if (!propertyValue) return;

          if (usesItemsArray) {
            formData.set(`items[0][properties][${propertyKey}]`, propertyValue);
          } else {
            formData.set(`properties[${propertyKey}]`, propertyValue);
          }
        });
      }

      hasBundleSelection(formData) {
        return formData
          .getAll('properties[_bundle_selection]')
          .some((value) => typeof value === 'string' && value.trim() !== '');
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
